export default __webpack_public_path__ + "static/media/Abalone-Knife.da26e4f8.jpg";